import React from 'react';
import { taggedLink } from '../helpers/linkTagging';

const Logo = ({ url, logo }, props) => {
  const splittedPath = logo.split('//');
  const logoPath = `//` + (splittedPath[1] || splittedPath[0]);

  return (
    <div className="logo">
      <a
        href={
          url
            ? url.match(/^[a-zA-Z]+:\/\//) ? url : 'http://' + url
            : `https://www.livechatinc.com/powered-by-livechat/${taggedLink(
                props,
                'logo'
              )}`
        }
      >
        <img src={logoPath} alt="Logo" />
      </a>
    </div>
  );
};

export default Logo;
